import { render, staticRenderFns } from "./PnlsPage.vue?vue&type=template&id=fa8c4fba"
import script from "./PnlsPage.vue?vue&type=script&lang=ts"
export * from "./PnlsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports